import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesLeadSourcesDataGrid } from "src/components/views/erp/sales/crm/salesLeadSources/SalesLeadSourcesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/crm/salesLeadSources")({
	staticData: { title: i18n.t("lead_sources"), legacyViewKey: "salesLeadSourcesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesLeadSourcesDataGrid />;
}
